export const SET_ALBBTOKEN = 'SET_ALBBTOKEN'
export const SET_FILETYPE = 'SET_FILETYPE'
export const SET_USERINFO = 'SET_USERINFO'
export const SET_USERSUPDATE = 'SET_USERSUPDATE'
export const SET_COMPANYUSERS = 'SET_COMPANYUSERS'
export const SET_COMPANYINFO = 'SET_COMPANYINFO'
export const SET_COMPANYID = 'SET_COMPANYID'
export const SET_PROJECTID = 'SET_PROJECTID'
export const SET_COMPANYTYPE = 'SET_COMPANYTYPE'
